import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import ProjectsHome from './CustomerComponents/ProjectsHome/ProjectsHome';
import DottedLoader from './DottedLoader';
import ENVIRONMENT from '../../environments';

const HomeRedirect = ({ history }) => {
  const [isAiCustomer, setIsAiCustomer] = useState(false);
  const [loadingSubscriptionData, setLoadingSubscriptionData] = useState(true);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);

  useEffect(() => {
    setLoadingSubscriptionData(true);    
    if (localStorage.getItem('username')) {
      
      axios.post(ENVIRONMENT.GET_UPDATE_SUBSCRIPTION_DATA, {
        "data": "subscription-plan",
        "username": localStorage.getItem('username')
      }).then(res => {
        if ((res.data.name.endsWith('_ai')) && (res.data.name != 'enterprise' || res.data.name != 'custom_contract')) {
          setIsAiCustomer(true);
          localStorage.setItem('is_ai_customer', 'true');
        }
        else if (localStorage.getItem('is_ai_customer') === 'true') {
          setIsAiCustomer(true);
        }
        setLoadingSubscriptionData(false);
        setSubscriptionChecked(true);
      }).catch(error => {
        console.error('Error checking subscription:', error);
        setLoadingSubscriptionData(false);
        setSubscriptionChecked(true);
      });
    }
  }, [localStorage.getItem('username')]);

  useEffect(() => {
    const fetchCompanyUsers = async () => {
      try {
        const companyId = localStorage.getItem('company_id');
        const currentUsername = localStorage.getItem('username');

        if (!companyId || !currentUsername) {
          return;
        }

        const response = await axios.post(ENVIRONMENT.GET_COMPANY_USERS, {
          company_id: companyId
        });

        if (response.data && response.data.users) {
          const currentUser = response.data.users.find(
            user => user.username === currentUsername
          );

          if (currentUser) {
            localStorage.setItem('user_role', currentUser.role);
          }
        }
      } catch (err) {
        console.error('Error fetching company users:', err);
      }
    };

    fetchCompanyUsers();
  }, [localStorage.getItem('company_id'), localStorage.getItem('username')]);

  useEffect(() => {
    if (isAiCustomer && subscriptionChecked) {
      history.push('/ai-asset-creator');
    }
  }, [isAiCustomer, subscriptionChecked, history]);

  // Show loading state while checking subscription
  if (loadingSubscriptionData || subscriptionChecked == false) {
    return <DottedLoader />;
  }

  // Show loading state while redirecting AI customers
  if (isAiCustomer) {
    return <DottedLoader />;
  }

  return <ProjectsHome />;
};

export default withRouter(HomeRedirect);
